import settings from "settings";
import systemSettings from "config/systemConstants";
import _ from 'underscore';

const compiledConstants = _.extend(systemSettings, settings);

export default compiledConstants;